import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Facebook, Instagram } from "lucide-react";
import { CONTACT_INFO, LEGAL, SOCIAL } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#1f2523] text-neutral-300">
      <div className="max-w-4xl mx-auto px-5 py-12 text-center">
        {/* Brand + copyright */}
        <p className="font-serif-brand text-2xl text-white">
          &copy; {CONTACT_INFO.year} {CONTACT_INFO.brand}
        </p>

        {/* Contact line */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
          <span className="inline-flex items-center gap-2">
            <MapPin size={15} className="text-[var(--teal)]" />
            {CONTACT_INFO.location}
          </span>
          <a
            href={`mailto:${CONTACT_INFO.email}`}
            className="inline-flex items-center gap-2 hover:text-white transition-colors"
          >
            <Mail size={15} className="text-[var(--teal)]" />
            {CONTACT_INFO.email}
          </a>
          <a
            href={`tel:+1${CONTACT_INFO.phone.replace(/\s/g, "")}`}
            className="inline-flex items-center gap-2 hover:text-white transition-colors"
          >
            <Phone size={15} className="text-[var(--teal)]" />
            Cell {CONTACT_INFO.phone}
          </a>
        </div>

        {/* Social links */}
        <div className="mt-6 flex items-center justify-center gap-3">
          <a
            href={SOCIAL.facebook}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow on Facebook"
            title="Follow on Facebook"
            className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-neutral-300 hover:bg-[var(--teal)] hover:text-white hover:border-[var(--teal)] hover:-translate-y-0.5 transition-all"
          >
            <Facebook size={18} />
          </a>
          <a
            href={SOCIAL.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow on Instagram"
            title="Follow on Instagram"
            className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-neutral-300 hover:bg-[var(--teal)] hover:text-white hover:border-[var(--teal)] hover:-translate-y-0.5 transition-all"
          >
            <Instagram size={18} />
          </a>
        </div>

        {/* Privacy / disclaimer */}
        <div className="mt-8 pt-8 border-t border-white/10">
          <Link
            to="/privacy"
            className="inline-block text-[11px] tracking-[0.22em] uppercase text-[var(--teal)] font-semibold mb-3 hover:text-white transition-colors"
          >
            {LEGAL.privacyTitle}
          </Link>
          <p className="text-xs leading-relaxed text-neutral-400 max-w-3xl mx-auto">
            {LEGAL.privacyText}
          </p>
          <Link
            to="/privacy"
            className="inline-block mt-4 text-xs text-[var(--teal)] font-semibold hover:text-white transition-colors"
          >
            Read our full Privacy Policy &rarr;
          </Link>
        </div>
      </div>
    </footer>
  );
}
